import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import { ApplicationContextConsumer } from 'context/ApplicationContext';
import {
  withApi,
  withNotification,
} from 'wrappers';
import endPoints from 'endPoints/endPoints';
import { Loader } from 'components';
import NavBar from './NavBar';
import TopBar from './TopBar';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%',
  },
  wrapper: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: 64,
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 0,
    },
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
  },
  contentContainerOpen: {
    marginLeft: 300,
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto',
  },
}));

function DashboardLayout({
  children,
  doGet,
  genericException,
}) {
  const classes = useStyles();
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [thumbnail, setThumbnail] = useState(null);

  const findImage = async () => {
    try {
      const { thumbnail: t } = await doGet({
        url: endPoints.seguridad.usuarios.getImageForUser,
      });
      setThumbnail(t);
      setLoading(false);
    } catch (e) {
      genericException(e);
    }
  };

  useEffect(() => {
    findImage();
    // eslint-disable-next-line
  }, []);

  const handleDrawerToggle = () => {
    setMobileNavOpen(!isMobileNavOpen);
  };

  return loading ? <Loader /> : (
    <ApplicationContextConsumer>
      {({ fetchPermissions, permissions = [] }) => (
        <div className={classes.root}>
          <TopBar
            onMobileNavOpen={handleDrawerToggle}
            isMobileNavOpen={isMobileNavOpen}
            fetchPermissions={fetchPermissions}
            permissions={permissions}
            thumbnail={thumbnail}
          />
          <NavBar
            onMobileClose={() => setMobileNavOpen(false)}
            openMobile={isMobileNavOpen}
            thumbnail={thumbnail}
          />
          <div className={classes.wrapper}>
            <div className={clsx(classes.contentContainer, {
              [classes.contentContainerOpen]: isMobileNavOpen,
            })}
            >
              <div className={classes.content}>
                {children}
              </div>
            </div>
          </div>
        </div>
      )}
    </ApplicationContextConsumer>
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.element,
  doGet: PropTypes.func,
  genericException: PropTypes.func,
};

export default withApi(withNotification(DashboardLayout));
